import React from 'react';
import styles from './feature-selector.module.scss';

type FeatureKey = 'experts' | 'learning' | 'interactive';

interface FeaturePaginationProps {
    features: Array<{
        key: FeatureKey;
        title: string;
    }>;
    selectedFeature: FeatureKey;
    onSelect: (feature: FeatureKey) => void;
}

const FeaturePagination: React.FC<FeaturePaginationProps> = ({
    features,
    selectedFeature,
    onSelect,
}) => {
    return (
        <div className={styles.paginationContainer}>
            {features.map((feature) => (
                <button
                    key={feature.key}
                    className={`${styles.paginationPill} ${
                        selectedFeature === feature.key ? styles.paginationPillActive : ''
                    }`}
                    onClick={() => onSelect(feature.key)}
                    aria-label={`Select ${feature.title}`}
                >
                    {feature.title}
                </button>
            ))}
        </div>
    );
};

export {FeaturePagination};
